import React from 'react';

import {OutlinePrimaryLink} from '../components/OutlinePrimaryLink';
import {PageMenu} from '../components/PageMenu';

export const AboutPage: React.FC = () => (
  <main>
    <PageMenu active="/about" />

    {/* ヒーロー */}
    <section className="border-b border-neutral-100 py-20 text-center">
      <div className="mx-auto max-w-[840px] px-4">
        <h1 className="mb-9 mt-8 text-3xl font-light tracking-[2.1px]">
          ACミハラについて
        </h1>

        <p className="mb-1 font-light">
          ACミハラは、広島県三原市にあるスペースです。
        </p>
        <p className="mb-1 font-light">
          会員登録をすると、イベントに参加したり、イベントを行うことが簡単にできます。
        </p>
        <p className="mb-1 font-light">
          イベントはもちろん、会議・研修・ミーティングなどのビジネスの場としても利用可能です。
        </p>

        <div className="mt-16">
          <OutlinePrimaryLink href="#feature" size="md" className="mx-2 w-56">
            <span>特徴</span>
          </OutlinePrimaryLink>
          <OutlinePrimaryLink href="#guide" size="md" className="mx-2 w-56">
            <span>ご利用ガイド</span>
          </OutlinePrimaryLink>
        </div>

        <div className="mt-8">
          <p className="font-light text-neutral-900">
            料金・フロアガイド・設備・サービスについてはこちら
          </p>
          <OutlinePrimaryLink href="/facility" size="md" className="mt-8">
            料金・施設について確認する
          </OutlinePrimaryLink>
        </div>
      </div>
    </section>

    {/* 特徴 */}
    <section
      id="feature"
      className="border-b border-neutral-100 py-20 text-center">
      <div className="text-center">
        <h2 className="mb-10 inline-flex border-b-2 border-primary pb-1 text-base font-semibold tracking-[1.2px] text-primary">
          特徴
        </h2>
      </div>

      <div className="flex flex-wrap justify-center">
        <div className="m-8 w-72 text-center">
          <img
            src="/assets/about/01.png"
            alt=""
            className="mb-6 block size-72 rounded-full border border-neutral-100 object-cover"
          />
          <p className="text-lg font-light text-neutral-900">
            マイページから簡単イベント作成
          </p>
          <p className="text-left text-sm leading-relaxed text-neutral-900">
            イベントを開催したいときは、イベント作成ページのフォームを使って簡単にイベントページが作れます。作成したイベントページはACミハラサイト内のイベントページに掲載されます。facebookやtwitterなどでイベントページをシェアしましょう。私たちも集客のお手伝いが可能です。
          </p>
        </div>
        <div className="m-8 w-72 text-center">
          <img
            src="/assets/about/02.png"
            alt=""
            className="mb-6 block size-72 rounded-full border border-neutral-100 object-cover"
          />
          <p className="text-lg font-light text-neutral-900">
            イベント参加の手続きが簡単
          </p>
          <p className="text-left text-sm leading-relaxed text-neutral-900">
            イベントに参加したいときは、ACミハラサイトに掲載されたイベントページの「チケットを申し込む」ボタンから参加申し込みができます。イベント当日は、イベント１ヶ月前になったら届くメールチケットを受付で見せるだけ。
          </p>
        </div>
        <div className="m-8 w-72 text-center">
          <img
            src="/assets/about/03.png"
            alt=""
            className="mb-6 block size-72 rounded-full border border-neutral-100 object-cover"
          />
          <p className="text-lg font-light text-neutral-900">オンライン決済</p>
          <p className="text-left text-sm leading-relaxed text-neutral-900">
            有料チケットの代金支払いも、イベントでACミハラのスペースを利用する場合の利用料も、クレジットカードがあればACミハラサイト上で決済できます。
          </p>
          <p className="text-xs text-neutral-500">
            ※チケット代金はACミハラが回収し、イベント開催後５営業日以内に主催者の指定口座に振込します。
          </p>
        </div>
        <div className="m-8 w-72 text-center">
          <img
            src="/assets/about/04.png"
            alt=""
            className="mb-6 block size-72 rounded-full border border-neutral-100 object-cover"
          />
          <p className="text-lg font-light text-neutral-900">
            充実した設備・サービス
          </p>
          <p className="text-left text-sm leading-relaxed text-neutral-900">
            新しくキレイなスペースで、プロジェクタや音響設備など無料でご利用できます。テーブルレイアウトも自由自在、複数スペースをつなげて広いスペースで大人数のイベントも可能です。
          </p>
        </div>
        <div className="m-8 w-72 text-center">
          <img
            src="/assets/about/05.png"
            alt=""
            className="mb-6 block size-72 rounded-full border border-neutral-100 object-cover"
          />
          <p className="text-lg font-light text-neutral-900">
            駅から徒歩5分の好アクセス
          </p>
          <p className="text-left text-sm leading-relaxed text-neutral-900">
            ACミハラスペースの場所は、新幹線もあるJR三原駅から徒歩５分。宿泊する場合はACミハラから徒歩30秒の
            <a
              href="http://www.superhotel.co.jp/s_hotels/mihara/"
              target="_blank"
              rel="noreferrer"
              className="text-primary">
              スーパーホテル三原駅前
            </a>
            をご利用ください。
          </p>
        </div>
      </div>
    </section>

    {/* ご利用ガイド：イベントの参加方法 */}
    <section
      id="guide"
      className="border-b border-neutral-100 py-20 text-center">
      <div className="text-center">
        <h2 className="mb-10 inline-flex border-b-2 border-primary pb-1 text-base font-semibold tracking-[1.2px] text-primary">
          ご利用ガイド
        </h2>
      </div>
      <div className="mx-auto w-[230px] rounded-full border border-neutral-100 px-6 py-1 text-sm font-bold text-neutral-900">
        イベントの参加方法
      </div>

      <div className="mt-12 flex flex-wrap justify-center">
        <div className="mx-4 my-8 w-[228px] text-center">
          <img
            src="/assets/about/06.png"
            alt=""
            className="mb-6 block h-[228px] w-[228px]"
          />
          <p className="text-2xl tracking-[-0.1px] text-primary">step.1</p>
          <p className="text-sm font-normal text-neutral-900">イベントを選ぶ</p>
          <p className="text-xs leading-relaxed text-neutral-700">
            イベントページから気になるイベントを探そう。
          </p>
        </div>
        <div className="my-8">
          <i className="fas fa-chevron-circle-right text-lg leading-[228px] text-gray-300" />
        </div>
        <div className="mx-4 my-8 w-[228px] text-center">
          <img
            src="/assets/about/07.png"
            alt=""
            className="mb-6 block h-[228px] w-[228px]"
          />
          <p className="text-2xl tracking-[-0.1px] text-primary">step.2</p>
          <p className="text-sm font-normal text-neutral-900">
            オンラインチケットを購入
          </p>
          <p className="text-xs leading-relaxed text-neutral-700">
            気になるイベントが見つかったら、申し込みボタンをクリック。購入はオンラインから簡単に決済可能。
          </p>
        </div>
        <div className="my-8">
          <i className="fas fa-chevron-circle-right text-lg leading-[228px] text-gray-300" />
        </div>
        <div className="mx-4 my-8 w-[228px] text-center">
          <img
            src="/assets/about/08.png"
            alt=""
            className="mb-6 block h-[228px] w-[228px]"
          />
          <p className="text-2xl tracking-[-0.1px] text-primary">step.3</p>
          <p className="text-sm font-normal text-neutral-900">イベントに参加</p>
          <p className="text-xs leading-relaxed text-neutral-700">
            「当日はオンラインチケットを持参。イベントに参加して「で・あ・い」を楽しもう。
          </p>
        </div>
      </div>

      <div className="mt-8 text-center">
        <OutlinePrimaryLink
          href="/#events"
          size="md"
          variant="filled"
          className="mt-8">
          イベントをさがす
        </OutlinePrimaryLink>
      </div>
    </section>

    {/* ご利用ガイド：イベントの作成方法 */}
    <section className="border-b border-neutral-100 py-20 text-center">
      <div className="mx-auto w-[230px] rounded-full border border-neutral-100 px-6 py-1 text-sm font-bold text-neutral-900">
        イベントの作成方法
      </div>

      <div className="mt-12 flex flex-wrap justify-center">
        <div className="my-8 w-52 text-center">
          <img
            src="/assets/about/09.png"
            alt=""
            className="mb-6 block size-52"
          />
          <p className="text-2xl tracking-[-0.1px] text-primary">step.1</p>
          <p className="text-sm font-normal text-neutral-900">ログイン</p>
          <p className="text-xs leading-relaxed text-neutral-700">
            会員登録していない方は会員登録をしよう。
          </p>
        </div>
        <div className="my-8">
          <i className="fas fa-chevron-circle-right text-lg leading-[208px] text-gray-300" />
        </div>
        <div className="my-8 w-52 text-center">
          <img
            src="/assets/about/10.png"
            alt=""
            className="mb-6 block size-52"
          />
          <p className="text-2xl tracking-[-0.1px] text-primary">step.2</p>
          <p className="text-sm font-normal text-neutral-900">
            イベント作成フォームに記入
          </p>
          <p className="text-xs leading-relaxed text-neutral-700">
            イベント作成ページのフォームに従って必要事項を記入しよう。
          </p>
          <p className="text-xs leading-relaxed text-neutral-700">
            ※イベントを非公開にする設定も可能です。会議・研修等でご活用ください。
          </p>
        </div>
        <div className="my-8">
          <i className="fas fa-chevron-circle-right text-lg leading-[208px] text-gray-300" />
        </div>
        <div className="my-8 w-52 text-center">
          <img
            src="/assets/about/11.png"
            alt=""
            className="mb-6 block size-52"
          />
          <p className="text-2xl tracking-[-0.1px] text-primary">step.3</p>
          <p className="text-sm font-normal text-neutral-900">
            イベントの申し込み
          </p>
          <p className="text-xs leading-relaxed text-neutral-700">
            フォームの記入が完了したら、申し込みボタンをクリック。
          </p>
        </div>
        <div className="my-8">
          <i className="fas fa-chevron-circle-right text-lg leading-[208px] text-gray-300" />
        </div>
        <div className="my-8 w-52 text-center">
          <img
            src="/assets/about/12.png"
            alt=""
            className="mb-6 block size-52"
          />
          <p className="text-2xl tracking-[-0.1px] text-primary">step.4</p>
          <p className="text-sm font-normal text-neutral-900">
            申し込みの承認を待つ
          </p>
          <p className="text-xs leading-relaxed text-neutral-700">
            スタッフがイベント内容を審査し承認いたします。
          </p>
          <p className="text-xs leading-relaxed text-neutral-700">
            ※最大3営業日かかります。
          </p>
        </div>
        <div className="my-8">
          <i className="fas fa-chevron-circle-right text-lg leading-[208px] text-gray-300" />
        </div>
        <div className="my-8 w-52 text-center">
          <img
            src="/assets/about/13.png"
            alt=""
            className="mb-6 block size-52"
          />
          <p className="text-2xl tracking-[-0.1px] text-primary">step.5</p>
          <p className="text-sm font-normal text-neutral-900">
            イベントページの完成
          </p>
          <p className="text-xs leading-relaxed text-neutral-700">
            イベントページが公開されたら友達にシェアしよう。
          </p>
        </div>
      </div>

      <div className="mt-8 text-center">
        <OutlinePrimaryLink
          href="/mypage/events/new?eventType=event"
          size="md"
          variant="filled"
          className="mt-8">
          イベントをつくる
        </OutlinePrimaryLink>
      </div>
    </section>

    {/* ご利用環境 */}
    <section className="border-b border-neutral-100 py-20 text-center">
      <div className="mx-auto px-4 text-center">
        <div className="inline-block">
          <p className="text-sm font-light text-neutral-900">
            ご利用環境について
          </p>
          <div className="text-left text-xs leading-relaxed text-neutral-700">
            当サイトをご利用いただくため、下記ブラウザの最新版をご利用ください。
            <br />
            {'　'}- Google Chrome
            <br />
            {'　'}- Safari
            <br />
            それ以外のブラウザは非推奨となっています。
          </div>
        </div>
      </div>
    </section>
  </main>
);
